import { AdaptiveSheet } from '../common';
import { useUIStore } from '../../store/uiStore';
import { useDesktopShell } from '@hooks/useDesktopShell';
import { MapLayersContent } from './MapLayersContent';

/**
 * Phone/tablet presentation of the map layers content: the gorhom sheet.
 * The desktop shell renders `MapLayersPanel.web` (a left-docked panel)
 * instead — see uiStore.layersPanelOpen — so this stays closed there even
 * if `activeSheet` is still 'mapLayers' from before the shell breakpoint
 * changed underneath it.
 */
export function MapLayersSheet() {
  const activeSheetIsLayers = useUIStore((s) => s.activeSheet === 'mapLayers');
  const sheetOpenTick = useUIStore((s) => s.sheetOpenTick);
  const close = useUIStore((s) => s.closeSheet);
  const isDesktopShell = useDesktopShell();
  const isOpen = activeSheetIsLayers && !isDesktopShell;

  const handleDismissed = () => {
    if (useUIStore.getState().activeSheet === 'mapLayers') close();
  };

  return (
    <AdaptiveSheet
      isOpen={isOpen}
      tick={sheetOpenTick}
      backdrop="light"
      onRequestClose={close}
      onDismiss={handleDismissed}
      dialogWidth={420}>
      <AdaptiveSheet.ScrollView testID="map-layers-sheet" showsVerticalScrollIndicator={false}>
        <MapLayersContent onClose={close} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
